module.exports = __webpack_public_path__ + "static/media/speaker-icon.03efd927.png";